module.exports = __webpack_public_path__ + "static/media/background.adda38a0.jpg";